import { TooltipWithBounds } from "@visx/tooltip";
import type { ReactNode } from "react";
import styles from "./ChartTooltip.module.css";

export interface ChartTooltipProps {
  top: number;
  left: number;
  children: ReactNode;
}

export function ChartTooltip({ top, left, children }: ChartTooltipProps) {
  return (
    <TooltipWithBounds top={top} left={left} className={styles.tooltip}>
      {children}
    </TooltipWithBounds>
  );
}
